import cx from 'classnames';
import { ReactElement } from 'react';

import { Button, ButtonProps } from '../form/button/Button';
import { Typography } from '../typography/Typography';

import { CrossButton } from './CrossButton';
import style from './ModalHeader.module.css';
import styles from './ModalHeaderWithButton.module.css';

export type ModalHeaderWithButtonProps = {
    title?: string | ReactElement;
    dark?: boolean;
    onClose?: () => void;
    buttonProps: ButtonProps;
};

export function ModalHeaderWithButton({
    title,
    dark,
    onClose,
    buttonProps,
}: ModalHeaderWithButtonProps) {
    return (
        <div className={cx(style.header, { [style.dark]: dark })}>
            <div className={style.title}>
                {title ? <Typography scale="primary-s-extra-bold">{title}</Typography> : null}
            </div>
            <div className={style.rightButton}>
                <div className={styles.buttonContainer}>
                    <Button {...buttonProps} />
                    {onClose ? (
                        <CrossButton onClick={onClose} className={style.crossButton} />
                    ) : null}
                </div>
            </div>
        </div>
    );
}
